import { InternationalizationStory } from '@aclass/admin/storage/actions';
import {
    IInternationalizationModuleState,
    INITIAL_INTERNATIONALIZATION_STATE
} from '@aclass/admin/storage/states';
import { Action } from '@aclass/core/storage/action';
import { TypedState } from '@aclass/core/storage/states/module.state';
import { fromJS, List, Map } from 'immutable';

export const internationalizationModuleReducer = (state: TypedState<IInternationalizationModuleState> = INITIAL_INTERNATIONALIZATION_STATE, action: Action) => {
    const { type, payload } = action;
    switch (type) {
        case InternationalizationStory.UPDATE_CATEGORY:
            return state.update('category', () => payload);
        case InternationalizationStory.SEARCH_PAGE_UPDATE_COLLAPSED:
            return state.update('searchPageCollapsed', () => payload);
        case InternationalizationStory.SEARCH_PAGE_UPDATE_FORM:
            return state.update('searchPageForm', () => fromJS(payload));
        case InternationalizationStory.SEARCH_PAGE_UPDATE_INIT_STATE:
            return state.update('searchPageInitialized', () => payload);
        case InternationalizationStory.SEARCH_PAGE_UPDATE_SEARCH_LOCK:
            return state.update('searchPageLock', () => payload);
        case InternationalizationStory.SEARCH_PAGE_UPDATE_PAGINATION:
            return state.update('searchPagePagination', () => Map(payload));
        case InternationalizationStory.SEARCH_PAGE_UPDATE_ORDER:
            return state.update('searchPageOrder', () => Map(payload));
        case InternationalizationStory.SEARCH_PAGE_IMPORT_RECORDS:
            return state.update('searchPageResults', () => List(payload));
        case InternationalizationStory.SHOW_PAGE_UPDATE_MESSAGE_ID:
            return state.update('showPageRecordId', () => payload);
        case InternationalizationStory.SHOW_PAGE_UPDATE_FORM:
            return state.update('showPageForm', () => fromJS(payload));
        default:
            return state;
    }
};
